<template>
  <div>
    <e-filters
      ref="filters"
      :title="$t('Filtros')"
      :searching="fetching"
      :show-search-button="false"
      @reset="resetFilters"
    >
      <template #after_buttons>
        <e-button
          id="download"
          class="ml-1 btn-sm-block"
          variant="primary"
          icon="download"
          :busy="fetching"
          :text="$t('Baixar Relatório')"
          @click="downloadReport"
        />
        <!-- Button to download report (hidden by default) -->
        <a
          ref="downloadLink"
          style="display: none"
        />
      </template>
      <b-row>
        <b-col md="4">
          <e-store-combo
            id="filter-stores"
            v-model="filters.storeIds"
            :required="false"
            :multiple="true"
            :placeholder="$t('Todas')"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="filter-account-type"
            v-model="filters.accountType"
            type="vue-select"
            :label="$t('Tipo de conta')"
            :placeholder="$t('Selecione')"
            :options="checkingAccountFilterTypeOptions()"
            class="required"
            validation="required"
          />
        </b-col>
        <b-col md="4">
          <FormulateInput
            id="filter-period"
            v-model="filters.period"
            type="date-range-picker"
            :label="$t('Período')"
            :time-picker="false"
            class="required"
            validation="required"
          />
        </b-col>
      </b-row>
    </e-filters>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { checkingAccountDomains, formulateValidation } from '@/mixins'
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import { EStoreCombo, EFilters } from '@/views/components'
import EButton from '@/views/components/EButton.vue'

const MAX_PERIOD_DAYS = 90

export default {
  components: {
    BRow,
    BCol,
    EFilters,
    EStoreCombo,
    EButton,
  },

  mixins: [formulateValidation, checkingAccountDomains],

  data() {
    return {
      fetching: false,
    }
  },

  computed: {
    ...mapState('pages/reports/financial/checkingAccountStatement', ['reportData', 'filters']),
  },

  methods: {
    ...mapActions('pages/reports/financial/checkingAccountStatement', [
      'generateReport',
      'resetFilters',
    ]),

    async downloadReport() {
      try {
        if (!this.$refs.filters.isValid()) return

        const { startDate, endDate } = this.filters.period
        if (
          !startDate ||
          !endDate ||
          moment(endDate).diff(moment(startDate), 'days') > MAX_PERIOD_DAYS
        ) {
          this.showInvalidDataMessage({
            message: this.$t('Informe um período de no máximo 90 dias para baixar o relatório'),
          })
          return
        }

        this.fetching = true
        await this.generateReport()

        const { downloadLink } = this.$refs
        if (!this.reportData) {
          this.showError({ message: this.$t('Não foi possível recuperar os dados do relatório') })
          return
        }

        const typeName = this.checkingAccountFilterTypeOptions()?.find(opt => opt.value === this.filters.accountType)?.label
          ?? this.filters.accountType

        downloadLink.href = this.reportData
        downloadLink.download = `ContaCorrente-${typeName}-Data_${startDate}_ate_${endDate}.xlsx`
        downloadLink.click()
      } catch (error) {
        this.showError({ error })
      } finally {
        this.fetching = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
